interface Props {}

/**
 * Page used to create a quiz session that can be shared with player.
 * Admin creates the quiz setup here and gets the sharable URL for the session.
 * @param props 
 * @returns 
 */
export const QuizSessionSetup = (props: Props) => {
    return (
        <>
            
        </>
    );
};